import Vue from 'vue'
import Router from 'vue-router'
import { localStorageCache, toLoginPage } from '@/assets/js/utils'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const index = r => require.ensure([], () => r(require('../pages/index')), 'index')
const knowledge = r => require.ensure([], () => r(require('../pages/knowledgeBase/knowledge')), 'knowledge')
const userCenter = r => require.ensure([], () => r(require('../pages/userCenter')), 'userCenter')
// const login = r => require.ensure([], () => r(require('../pages/login')), 'login')
const document = r => require.ensure([], () => r(require('../pages/knowledgeBase/document')), 'document')
const articleDetail = r => require.ensure([], () => r(require('../pages/knowledgeBase/articleDetail')), 'articleDetail')
const newSlist = r => require.ensure([], () => r(require('../pages/news/newSlist')), 'newSlist')
const detail = r => require.ensure([], () => r(require('../pages/news/detail')), 'detail')
const lessonMore = r => require.ensure([], () => r(require('../pages/lesson/lessonMore')), 'lessonMore')
const lessonList = r => require.ensure([], () => r(require('../pages/lesson/lessonList')), 'lessonList')
const lessonDetail = r => require.ensure([], () => r(require('../pages/lesson/lessonDetail')), 'lessonDetail')
const manylessonDetail = r => require.ensure([], () => r(require('../pages/lesson/_id')), 'manylessonDetail')
const hotList = r => require.ensure([], () => r(require('../pages/hot/hotList')), 'hotList')
const liveList = r => require.ensure([], () => r(require('../pages/live/liveList')), 'liveList')
const testList = r => require.ensure([], () => r(require('../pages/test/testList')), 'testList')
const anounceList = r => require.ensure([], () => r(require('../pages/anounceList')), 'anounceList')
Vue.use(Router)

const router = new Router({
  // mode: "history",
  // base:'/dist/',
  routes: [
    { // 首页
      path: '/',
      name: 'index',
      meta: {title: '首页'},
      component: index
    },
    { // 公告列表
      path: '/anounceList',
      name: 'anounceList',
      meta: {title: '公告列表'},
      component: anounceList
    },
    { // 知识库
      path: '/knowledgeBase/knowledge/:id?',
      name: 'knowledge',
      meta: {title: '知识库'},
      component: knowledge
    },
    { // 个人中心
      path: '/userCenter',
      name: 'userCenter',
      meta: {title: '个人中心'},
      component: userCenter
    },
    { // 文档页
      path: '/knowledgeBase/document',
      name: 'document',
      meta: {title: '文档'},
      component: document
    },
    { // 文章详情
      path: '/knowledgeBase/articleDetail',
      name: 'articleDetail',
      meta: {title: '文章详情'},
      component: articleDetail
    },
    { // 资讯列表
      path: '/news/newSlist',
      name: 'newSlist',
      meta: {title: '资讯列表'},
      component: newSlist
    },
    { // 文章详情
      path: '/news/detail',
      name: 'detail',
      meta: {title: '文章详情'},
      component: detail
    },
    { // 课程中心
      path: '/lesson/lessonMore',
      name: 'lessonMore',
      meta: {title: '课程中心'},
      component: lessonMore
    },
    { // 课程内容列表
      path: '/lesson/lessonList',
      name: 'lessonList',
      meta: {title: '课程内容列表'},
      component: lessonList
    },
    { // 单课的详情页面
      path: '/lesson/lessonDetail',
      name: 'lessonDetail',
      meta: {title: '单课的详情页面'},
      component: lessonDetail
    },
    { // 多课的详情页面
      path: '/lesson/:id?',
      name: 'manylessonDetail',
      meta: {title: '单课的详情页面'},
      component: manylessonDetail
    },
    { //专栏内容
      path: '/hot/hotList',
      name: 'hotList',
      meta: {title: '专栏内容'},
      component: hotList
    },
    { //直播详情页
      path: '/live/liveList',
      name: 'liveList',
      meta: {title: '直播内容'},
      component: liveList
    },
    {// 考试详情页
      path: '/test/testList',
      name: 'testList',
      meta: { title: '考试详情' },
      component:testList
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
     return savedPosition
    } else {
     return { x: 0, y: 0 }
    }
    }
})

router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  if (!localStorageCache.fetch('token')) { 
    toLoginPage()
    return 
  }
  next()
})
export default router